export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Caramel colorant (Liquide)-98cf2a57bd509bae31edd1e7068921d3.pdf";